<template>
  <div
    class="ui-checkbox"
    :disabled="disabled"
    :valid="valid"
    :touched="touched"
    sklepalnik-ui-element
  >
    <input type="checkbox" :name="name"/>
    <div
      class="checkbox__box"
      @click="toggle($event)"
      :class="{ 'extra-margin': label }"
    >
      <div class="checkbox__box-check" v-if="value"></div>
    </div>

    <p class="label" @click="toggle($event)" v-if="label">{{ label }}</p>
    <p class="title" @click="toggle($event)" v-if="title">{{ title }}</p>
    <p class="text" v-if="text">{{ text }}</p>
    <div class="clearfix"></div>

    <field-validator
      class="validator"
      v-if="showValidator()"
      ref="validator"
      :required="required"
      :validate="validate"
      :fieldname="name"
      :limit="true"
      :value="value"
      :type="Boolean"
      v-on:run-result="
        valid = $event;
        $emit('validated');
      "
    ></field-validator>
  </div>
</template>

<script>
import Vue from "vue";
import FieldValidator from "./FieldValidator.vue";
import {
  FieldValidatorProps,
  FieldValidatorAcknowledgeFG,
} from "./FieldValidatorUtils";

export default {
  name: "ui-checkbox",
  data: function () {
    return {
      valid: true,
      touched: false,
      fg: undefined,
    };
  },
  components: {
    "field-validator": FieldValidator,
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    required: FieldValidatorProps.Required,
    validate: FieldValidatorProps.Validate,
  },
  methods: {
    toggle(event) {
      event.stopPropagation();
      if (this.disabled) return;
      this.$emit("change", !this.value);
      this.$emit("fg-value-change");
      this.touched = true;
    },
    showValidator() {
      return (this.validate || this.required) && this.fg;
    },
    hasValidator() {
      return this.required || this.validate;
    },
    runValidator() {
      if (this.hasValidator()) {
        return this.$refs.validator.run();
      }
    },
    isValid() {
      return this.valid;
    },
    isTouched() {
      return this.touched;
    },
  },
  watch: {
    value() {
      Vue.nextTick(() => {
        this.runValidator();
      });
    },
    required() {
      Vue.nextTick(() => {
        this.fg.onElementValidateChanged(this);
      });
    },
    validate() {
      Vue.nextTick(() => {
        this.fg.onElementValidateChanged(this);
      });
    },
  },
  mounted: function () {
    FieldValidatorAcknowledgeFG.bind(this)();

    if (this.required || this.validate) {
      this.valid = false;
    } else {
      this.valid = true;
    }
  },
  destroyed: function () {
    this.fg.onChildDestroyed(this);
  },
};
</script>

<style scoped>
@media (min-width: 280px) {
  /* galaxy fold */
  .ui-checkbox {
    width: 100%;
    max-width: 345px;
    margin: 16px 0;
  }

  .ui-checkbox input {
    display: none;
  }

  .ui-checkbox .checkbox__box {
    position: relative;
    width: 24px;
    height: 24px;
    margin-right: 16px;

    background-color: white;
    border: 1px solid #4c4c4c;

    cursor: pointer;

    display: inline-block;
  }

  .ui-checkbox[touched]:not([valid]) .checkbox__box {
    border: 1px solid #ed1c24;
  }

  .ui-checkbox[disabled] .checkbox__box {
    border: 1px solid #e5e5e5;
    cursor: not-allowed;
  }

  .ui-checkbox .checkbox__box .checkbox__box-check {
    position: absolute;
    left: 3px;
    top: 3px;

    height: 16px;
    width: 16px;

    background-color: #1ea89c;
  }

  .ui-checkbox[disabled] .checkbox__box .checkbox__box-check {
    background-color: #e5e5e5;
  }

  .ui-checkbox .label {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #4c4c4c;

    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */

    margin: 0;

    cursor: pointer;

    display: inline-flex;
    align-items: center;
    width: calc(100% - 45px);
    vertical-align: top;
    min-height: 24px;
  }

  .ui-checkbox .title {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 45px);

    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 16px !important;
    line-height: 25px !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
    color: #4c4c4c;

    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */

    cursor: pointer;
    margin: 0 !important;
  }

  .ui-checkbox .text {
    font-family: "Open Sans";
    font-style: normal;
    font-size: 16px !important;
    line-height: 25px !important;
    color: #4c4c4c;

    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */

    margin: 0;
    padding-left: 40px;
  }

  .ui-checkbox[disabled] .label,
  .ui-checkbox[disabled] .title,
  .ui-checkbox[disabled] .text {
    color: #e5e5e5;
    cursor: unset;
  }

  .ui-checkbox .validator {
    width: 100%;
  }
}

@media (min-width: 320px) {
  .ui-checkbox .label {
    max-width: 250px;
    letter-spacing: 5px;
  }
}

@media (min-width: 768px) {
  .ui-checkbox {
    max-width: 600px;
  }

  .ui-checkbox .label,
  .ui-checkbox .title {
    max-width: 550px;
  }
}
</style>
